import React from 'react';
import { connect } from "react-redux";
import Loader from '../../../../Global/loader.js'
import { store } from 'react-notifications-component';
import BootstrapTable from 'react-bootstrap-table-next';
import { AiFillEdit } from 'react-icons/ai'
import { RiDeleteBin5Line } from 'react-icons/ri'
import Modal from 'react-modal';
import deleteUser from '../../../../API/Provider/DeleteUser'
import { Button } from "react-bootstrap";
import Create from './Create.js'
import Update from './Update.js'
import { BsBackspaceFill } from 'react-icons/bs'
import { withNamespaces } from 'react-i18next';
import getProviderUsersList from '../../../../API/Provider/GetUsersList';
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import updateUser from '../../../../API/Provider/PutUser'
import history from '../../../../history.js';
import { Form, Row } from 'react-bootstrap'
import CreateButton from '../../../../Global/CreateButton.js';

class Porezi extends React.Component {
    constructor(props) {
        super(props)
    
        this.state={
            loading: true,
            create: false,
            showDeleteModal: false,     
            uuidForDelete: "",  
            showOneItem: false,
            
            customStyles: {
                content : {
                    top                   : '50%',
                    left                  : '50%',
                    right                 : 'auto',
                    bottom                : 'auto',
                    transform             : 'translate(-50%, -50%)',
                    color: 'red'
                }
            }  
            
        }
    }

    componentDidMount = async () => {        
        document.title = this.props.t("Users") + "-" + this.props.t("List")
        this.setState({loading: true})


        await this.search()

        await this.setState({
            loading: false            
        })
    }

    toggleCreate(){
        this.setState({
            create: !this.state.create
        })
    }

    backFromCreate(){
        this.setState({
            create: !this.state.create
        })
        this.componentDidMount()
       
    }

    showDeleteModal = (uuid, countryUuid) => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            uuidForDelete: uuid,
            countryUuid: countryUuid
        });
    };

    confirmDelete = async () => {
        
        let deleteItem = await deleteUser(this.props.oneProvider.uuid, this.state.uuidForDelete)   
        if(deleteItem.data.status !== 200){
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: "",
                countryUuid: ""
            })     
            await store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t("There was an error deleting user, please try again"),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 15000,
                  onScreen: true
                }
            }) 

            this.search()
        }
        else{
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: "",
                countryUuid: ""
            }) 

            await store.addNotification({
                title: this.props.t('Success!'),
                message: this.props.t("User been deleted"),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            }) 

            this.search()
        }
    }

    seeDetails = async (data) => {        
        await this.props.mapState("MAP_PROVIDER_ONE_USER", data)
        await this.setState({
            showOneItem: !this.state.showOneItem
        })
        
    }

    backFromEdit = async () =>{
        this.setState({
            showOneItem: !this.state.showOneItem
        })
        this.search()
    }

    goBack(){
        history.goBack();
    }

    search = async() => {

        await this.setState({ loading: true})

        let lista = await getProviderUsersList(this.props)

        if(lista.data.status === 200){
            this.props.mapState("MAP_PROVIDER_USERS_LIST", lista.data.data.users)
        }
        else{
            this.props.mapState("MAP_PROVIDER_USERS_LIST", [])
        }
        
        await this.setState({ loading: false})
    }

    handlePageChange(pageNumber) {

        this.props.mapState("MAP_PROVIDER_TAX_RATE_LIST_ACTIVE_PAGE", pageNumber);

        this.search();
    }

    handleItemsPerPageChange(itemsPerPage) {
        this.setState({ itemsPerPage: itemsPerPage });

        this.search();
    }

    onItemsPerPageChange = async (size) => {
        this.props.mapState("MAP_PROVIDER_TAX_RATE_LIST_PAGE_SIZE", size);
        this.props.mapState("MAP_PROVIDER_TAX_RATE_LIST_ACTIVE_PAGE", 1);
        this.search();
    };

    toggleOnlyActive = async (data) => {
        this.setState({
            loading: true
        })

        await this.props.mapState("MAP_PROVIDER_TAX_RATE_ACTIVE_ONLY", data)
        await this.search();       
    }
   
    render(){  
        const { loading, create, showOneItem} = this.state 
        const { t } = this.props

        const columns = [{
            dataField: 'username',
            text: t('Username'),
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.provider.user.username
        }, {
            dataField: 'oib',
            text: t('OIB'),
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.provider.user.oib
        }, {
            dataField: 'email',
            text: t('Email'),
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"},   
            hidden: this.props.user.user_web_properties.columns.provider.user.email
        },{
            dataField: 'first_name',
            text: t('First Name'),
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.provider.user.first_name
        }, {
            dataField: 'last_name',
            text: t('Last Name'),
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.provider.user.last_name
        }, {
            dataField: 'account_non_expired',
            text: t('user Expired'),
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.provider.user.account_non_expired, 
            formatter: (cellContent, row) => {          
            return (
                <div key={row.uuid} className={`${row.account_non_expired ? "color-green" : "color-red"}`}>
                    <strong>
                        { row.account_non_expired ?  t("Yes") : t("No") }
                    </strong>
                </div>
            );
            }
        },{
            dataField: 'user_non_expired',
            text: t('Account Expired'),
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.provider.user.user_non_expired,
            formatter: (cellContent, row) => {          
            return (
                <div key={row.uuid} className={`${row.user_non_expired ? "color-green" : "color-red"}`}>
                    <strong>
                        { row.user_non_expired ?  t("Yes") : t("No") }
                    </strong>
                </div>
            );
            }
        },{
            dataField: 'account_non_locked',
            text: t('Account Locked'),
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.provider.user.account_non_locked,
            formatter: (cellContent, row) => {
            return (
                <div key={row.uuid} className={`${row.account_non_locked ? "color-green" : "color-red"}`}>
                    <strong>
                        { row.account_non_locked ?  t("Yes") : t("No") }
                    </strong>
                </div>
            );
            }
        },{
            dataField: 'enabled',
            text: t('Enabled'),
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.provider.user.enabled,
            formatter: (cellContent, row) => {          
            return (
                <div key={row.uuid} className={`${row.enabled ? "color-green" : "color-red"}`}>
                    <strong>
                        { row.enabled ?  t("Yes") : t("No") }
                    </strong>
                </div>
            );
            }
        },{
            dataField: "created",
            text: t("Created"),
            style: { wordWrap: "break-word" },
            headerStyle: { wordWrap: "break-word" },
            hidden: this.props.user.user_web_properties.columns.provider.user.created
        },{
            dataField: 'sakriveno',
            isDummyField: true,
            text: '',
            style:{ width: '11.8em' },
            formatter: (cellContent, row) => {          
            return (
                row.enabled ?
                <div key={row.uuid}>
                    <Button 
                        variant='success'
                        className="btnDetalji me-2" 
                        onClick={() =>this.seeDetails(row)}
                    > 
                        <AiFillEdit /> {t('Details')} 
                    </Button> 

                    <Button
                        variant='danger'
                        className="btnIzbrisi"
                        onClick={() => this.showDeleteModal(row.uuid, row.country_uuid)}
                    >
                        <RiDeleteBin5Line /> {t('Delete')}
                    </Button>
                </div>
                : null
            );
            }
        }]  

        /* CUstom filter buttons */
        const CustomToggleList = ({ columns, onColumnToggle, toggles}, customFunkcija) => {

            //asiknrona funkcija za poziv default toggler funkcije + sprmenje promjene za poziv prema serveru
            customFunkcija = async (column) => {
                await onColumnToggle(column.dataField)
                let data = { menu: "provider", view: "user" , column: column.dataField }
                await this.props.mapState("USER_MAP_COLUMNS", data)
                await updateUser(
                    this.props.user,
                    this.props.user.provider_uuid
                )
            }
            
            return <div className="btn-group btn-group-toggle " data-toggle="buttons">
              {columns
                .filter(data => data.dataField !== "sakriveno")
                .map(column => ({
                  ...column,
                  toggle: toggles[column.dataField]
                }))
                .map((column) => (
                    <button                         
                        key = {column.dataField}
                        type="button" 
                        className={ ` ${column.toggle ? ' btn btn-success active' : 'btn btn-danger'}` }
                        data-toggle="button" 
                        label={column.text}
                        id={column.dataField}
                        aria-pressed={(column.toggle) ? "true" : "false"}
                        onClick={() => customFunkcija(column) }
                    >
                        {column.text}
                    </button>
                ))}
            </div>
        };

    return (
        <div>
        {loading ? 
            <Loader />
        :
            <div>
                {create ? 
                    <Create goBack={() => this.backFromCreate()} />
                :
                showOneItem ? 
                    <Update goBack={() => this.backFromEdit()} />
                :
                    <div>
                        
                        <Form.Group as={Row} className="mb-3">
                            <CreateButton className="col-6 col-xl-4 p-4" toggleCreate={this.toggleCreate}/>
                        </Form.Group>
                        
                        {this.props.usersList.length > 0 ?
                        <div>
                            <ToolkitProvider
                                keyField="uuid"
                                data={this.props.usersList}
                                columns={columns}
                                columnToggle     
                                prikaziSakrij = {this.prikaziSakrij}    
                                bodyStyle={ {wordBreak: 'break-word'} }                         
                            >
                                {(props) => (
                                <div>
                                    <CustomToggleList {...props.columnToggleProps} />
                                    <hr />
                                    <BootstrapTable {...props.baseProps} hover bodyClasses="table-body" />
                                </div>
                                )}
                            </ToolkitProvider>

                        </div>
                        : 
                            <div className="list-empty-container">
                                <h1>{t(this.props.message)}</h1>
                            </div>  
                        }

                        <Modal
                            isOpen={this.state.showDeleteModal}                
                            onRequestClose={() => this.showDeleteModal("")}
                            style={this.state.customStyles}
                        >

                            <h3 className="modal-title">{t('Warning!')}</h3>
                            
                            <div className="mb-4">
                                <p>
                                    {t('Deleting the user will also delete other data related to it.')}       
                                </p>                     
                            </div>

                            <Row>
                                <div className="col col-6">
                                    <Button variant="primary" onClick={() => this.showDeleteModal("")}>{t('Close')}</Button>
                                </div>
                                <div className="col col-6">
                                    <Button variant="danger" onClick={() => this.confirmDelete()}> {t('DELETE')}</Button>
                                </div>                
                            </Row>
                    
                        </Modal> 

                        <div className="form-group mt-5">
                            <div
                                className="btn btn-default mb-2"
                                onClick={() => history.goBack()}                       
                            > 
                                <BsBackspaceFill size={30} />  
                                <strong> {t('Back')} </strong>
                            </div> 
                        </div>    
                    </div>
                }
                         
            </div>
        }
        </div>
    )
}
}
const mapStateToProps = state => {
    return {
        message: state.adminClient.message,
        user: state.user,
        activeOnly: state.provider.activeOnlyTaxRate,
        pageSize: state.provider.pageSizeTaxRate,
        activePage: state.provider.activePageTaxRate,
        usersList: state.provider.usersList,
        providerUserVisibleColumns: state.provider.providerUserVisibleColumns,
        oneProvider: state.provider.oneProvider
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(Porezi));